import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

interface JobsContextData {
  jobsCount: number | undefined;
  setJobsCount: Dispatch<SetStateAction<number | undefined>>;
}

export const JobsContext = createContext<JobsContextData | undefined>(
  undefined,
);

const JobsProvider = ({ children }: { children: ReactNode }) => {
  const [jobsCount, setJobsCount] = useState<number | undefined>();

  return (
    <JobsContext.Provider
      value={{
        jobsCount,
        setJobsCount,
      }}
    >
      {children}
    </JobsContext.Provider>
  );
};

export default JobsProvider;
